module.exports = __webpack_public_path__ + "static/media/box2.d1e059ef.png";